/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import type { Color } from "chroma-js";
import chroma from "chroma-js";

export default function findMatchingLuminosity(
  colorScale: (_: number) => Color,
  length: number,
  luminosities: number[],
  smooth: boolean,
) {
  const round = (x: number, n = 0) => Math.round(x * 10 ** n) / 10 ** n;
  const colorSearch = (x: number) => {
    const firstColor = smooth ? chroma(colorScale(0)).hsluv()[2] : colorScale(0).hsluv()[2];
    const lastColor = smooth ? chroma(colorScale(length)).hsluv()[2] : colorScale(length).hsluv()[2];

    const direction = firstColor < lastColor ? 1 : -1;
    const ε = 0.01;
    x += 0.005 * Math.sign(x);

    let step = length / 2;
    let dot = step;
    let value = smooth ? chroma(colorScale(dot)).hsluv()[2] : colorScale(dot).hsluv()[2];
    let counter = 100;

    while (Math.abs(value - x) > ε && counter) {
      counter--;
      step /= 2;
      if (value < x) {
        dot += step * direction;
      } else {
        dot -= step * direction;
      }
      value = smooth ? chroma(colorScale(dot)).hsluv()[2] : colorScale(dot).hsluv()[2];
    }
    return round(dot, 3);
  };

  const outputColors: string[] = [];
  luminosities.forEach((luminosity) => {
    if (smooth) {
      const findColor = colorScale(colorSearch(+luminosity));
      outputColors.push(chroma(findColor).hex());
      return;
    }

    outputColors.push(colorScale(colorSearch(+luminosity)).hex());
  });

  return outputColors;
}
